// extracted by mini-css-extract-plugin
export default {"breadCrumbs":"bread-crumbs_breadCrumbs__R2DoO","firstPart":"bread-crumbs_firstPart__dy9UE","secondPart":"bread-crumbs_secondPart__uc+7m"};